import React from "react";

function NewFranchiseeKn() {
  return (
    <div className="body-content">
      <div class="letters-color-section">
        <div class="main_header">ಹೊಸ ಫ್ರಾಂಚೈಸಿ ವಿಧಾನ</div>
        <div class="main-container Itsmc">
          <div class="main-header">
            ಮುಂಗಡ ರಿಸರ್ವೇಶನ್ -ಅಧಿಸೂಚನೆಗಾಗಿ ಫ್ರಾಂಚೈಸಿಗಳ ನೇಮಕಾತಿ
          </div>
          <div class="report-item-list">
            <ul>
              <li>
                ಬೆಂಗಳೂರು ನಗರ ಮತ್ತು ಕರ್ನಾಟಕ ರಾಜ್ಯದ ಇತರ ಸ್ಥಳಗಳಲ್ಲಿ ಸೀಟುಗಳ ಮುಂಗಡ
                ಮೀಸಲಾತಿಯ ಫ್ರಾಂಚೈಸಿಗಳ ನೇಮಕಾತಿ
              </li>
              <li>
                ಕರ್ನಾಟಕ ರಾಜ್ಯದ ಹೊರಗಿನ ಸ್ಥಳಗಳಲ್ಲಿ ಹೊಸ ಫ್ರಾಂಚೈಸಿಗಳ ನೇಮಕಾತಿ
                ಪ್ರಕ್ರಿಯೆ
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NewFranchiseeKn;
